import { render } from "./ConformationPopup.vue?vue&type=template&id=2994c8e5&scoped=true"
import script from "./ConformationPopup.vue?vue&type=script&lang=js"
export * from "./ConformationPopup.vue?vue&type=script&lang=js"

import "./ConformationPopup.vue?vue&type=style&index=0&id=2994c8e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2994c8e5"]])

export default __exports__